import { render, staticRenderFns } from "./DeleteProgram.vue?vue&type=template&id=7c77cbeb"
import script from "./DeleteProgram.vue?vue&type=script&lang=ts"
export * from "./DeleteProgram.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports